import * as React from 'react';
import { ScrollView, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import Footer from '@/components/footer';
import Navbar from '@/components/navbar';
import { isDesktop } from '@/core';

import { Hero } from './hero';
import {
  AppCta,
  AppFeatures,
  GetMore,
  PopularLocations,
  PopularPicks,
} from './sections';

export default function Home() {
  const { styles, theme } = useStyles(stylesheet);

  return (
    <View style={styles.parent}>
      {!isDesktop() ? (
        <Navbar
          style={{ backgroundColor: theme.colors.card.default.backgroundColor }}
        />
      ) : null}

      <ScrollView
        style={{ flex: 1 }}
        contentContainerStyle={{ flexGrow: 1 }}
        showsVerticalScrollIndicator={false}
      >
        <View style={{ width: '100%', alignItems: 'center' }}>
          <Hero />

          <View style={styles.content}>
            <PopularPicks />
            <AppFeatures />
            <GetMore />
            <PopularLocations />
            <AppCta />
          </View>

          <Footer />
        </View>
      </ScrollView>
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  parent: {
    backgroundColor: theme.colors.background_1,
    flex: 1,
  },
  content: {
    width: '100%',
    maxWidth: 1200,
    alignSelf: 'center',
    gap: 80,
    padding: 16,
    paddingBottom: 50,
  },
}));
